/** @file openTileAt: a double-click on a part opens its Tile tab at the tile the viewport draws for it. */
import { jointsFor } from './jointsFor';
import { pickNode } from './pickNode';
import { quadAt } from './quadAt';
import { shownTileOf } from './shownTileOf';
import type { ViewportCtx } from './viewportCtx';

/**
 * The part under `p` (target px; its picture or quad, `quadAt`) opens `openTile(shownTileOf(...))`. With the joints
 * shown, a double-click on a joint head or bone does nothing new (it stays a selection click). False when nothing opened.
 */
export function openTileAt(ctx: ViewportCtx, p: readonly [number, number]): boolean {
  const puppet = ctx.puppet();
  if (ctx.mode !== 'edit' || puppet === null || ctx.scene === null) return false;
  const s = ctx.store.getState();
  if (s.camera.joints && pickNode(jointsFor(ctx), puppet.instance.state().pose, ctx.scene.camera.view(), p) !== null) return false;
  const index = quadAt(ctx, p);
  const ref = index < 0 ? null : shownTileOf(ctx, index);
  if (ref === null) return false;
  s.openTile(ref);
  return true;
}
